import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

const ImageAltText = ({ instanceNumber, descriptionText, restrictUserInput, allowImages }) => {
  const [isAltTextSectionOpen, setIsAltTextSectionOpen] = useState(true);
  const altTextSection = useRef(null);
  const maxChars = 120;

  const toggleAltTextSection = () => {
    if (!altTextSection.current) {
      return;
    }

    setIsAltTextSectionOpen(!isAltTextSectionOpen);
  };

  return (
    <div className="ugc-contribution-modal__alt-text he-grid-col-md-12">
      <button        
        aria-controls={`description-container-${instanceNumber}`}
        aria-expanded={isAltTextSectionOpen}
        type="button"
        onClick={toggleAltTextSection}>
        <label
          htmlFor={`description${instanceNumber}`}>
          Step 2: Add Alt Text (optional)
        </label>
        <span
          aria-hidden="true"
          className={`icon icon--${isAltTextSectionOpen ? 'minus' : 'plus'}`}/>
      </button>
      <div
        id={`description-container-${instanceNumber}`}
        ref={altTextSection}
        className={`ugc-contribution-modal__alt-text-description-container ${isAltTextSectionOpen ? 'is-open' : ''}`}>
        <p>
          Add alt text to describe your photo to someone who is blind or has a visual impairment.
        </p>
        <textarea
          id={`description${instanceNumber}`}
          className="ugc-contribution-modal__alt-text-image-description form-control"
          name="ImageDescriptions"
          rows="4"
          value={descriptionText}
          disabled={allowImages !== undefined && allowImages}
          onChange={(e) => restrictUserInput(e.target.value)}/>
        <div id="comments-character-count"
          className="ugc-contribution-modal--alias-character-count">
          {maxChars - descriptionText.length} characters left
        </div>
      </div>
    </div>
  )
};

ImageAltText.propTypes = {
  instanceNumber: PropTypes.string.isRequired,
  descriptionText: PropTypes.string.isRequired,
  restrictUserInput: PropTypes.func.isRequired,
  allowImages: PropTypes.bool
};

export default ImageAltText;